<template>
  <v-card class="offer-schedule-list-container">
    <div class="header mb-4">
      <div class="title-container">
        <span>Propostas da indústria</span>
      </div>

      <div class="extra-container">
        <industry-proposal-sorting @change="changeSorting" />
        <mf-search v-model="search" dense hide-details placeholder="Buscar" />
      </div>
    </div>

    <div v-if="loading && firstLoading">
      <mf-loading v-for="i in 3" :key="i" class="item-loader" :booleanLoader="loading" :loaderType="isMobile ? 'card' : 'dynamic'" :dynamic-amount="2" />
    </div>

    <v-progress-linear v-if="loading && !firstLoading" indeterminate />
    <div v-if="!loading && !firstLoading" class="progress-linear-substitute"></div>

    <div v-if="!firstLoading" style="display: flex; flex-direction: column; gap: 16px">
      <div v-if="offerSchedules.length === 0" class="empty-item">
        <span>Nenhuma proposta da indústria foi encontrada.</span>
      </div>
      <offer-schedule-list-item v-for="offerSchedule in offerSchedules" :key="offerSchedule._id" :offer-schedule="offerSchedule" />
      <v-pagination
        v-if="offerSchedules.length > 0"
        v-model="page"
        class="mt-4"
        :class="{ 'justify-center': isMobile, 'justify-end': !isMobile }"
        :length="dataCount"
        @input="getData"
      />
    </div>
  </v-card>
</template>

<script>
import { QUERY_LIST_PROPOSAL_OFFER_SCHEDULES } from '@/modules/industria/ofertas-trade/graphql'
import OfferScheduleListItem from './OfferScheduleListItem.vue'
import IndustryProposalSorting from './IndustryProposalSorting.vue'
import { mapGetters, mapState } from 'vuex'

export default {
  name: 'OfferScheduleList',
  components: {
    OfferScheduleListItem,
    IndustryProposalSorting,
  },
  data: () => ({
    loading: true,
    firstLoading: true,
    offerSchedules: [],
    indexOfOpenedPanel: null,
    page: 1,
    pageSize: 10,
    dataCount: 0,
    search: '',
    debounceSearch: '',
    timer: null,
    sortBy: ['start_date'],
    sortDirection: ['ASC'],
  }),
  computed: {
    ...mapState({
      stateFilters: (state) => state.filters,
    }),

    ...mapGetters(['getSelectedIndustriesIds']),

    queryVariables() {
      const queryVariables = {
        status: ['industry_proposal'],
        search: this.debounceSearch,
        page: this.page || 1,
        pageSize: this.pageSize || 10,
        format: this.stateFilters.mechanics || [],
        sort: this.sortBy,
        sortDirection: this.sortDirection,
        franchise: false,
        includeAuto: false,
        industry: true,
        industryIds: this.getSelectedIndustriesIds,
      }

      if (this.stateFilters.mechanics.includes('nextbuycashback')) {
        queryVariables.format = this.stateFilters.mechanics.concat('cashback_absolute')
      }

      return queryVariables
    },
  },
  watch: {
    search(newValue, _) {
      clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        this.page = 1
        this.debounceSearch = newValue
        this.getData()
      }, 300)
    },
  },
  mounted() {
    this.getData()
    this.$nextTick(() => {
      this.$bus.$on('filter', () => {
        this.page = 1
        this.getData()
      })
    })
  },
  beforeDestroy() {
    this.$bus.$off('filter')
  },
  methods: {
    changeSorting(newSorting) {
      this.sortBy = newSorting.sortBy
      this.sortDirection = newSorting.sortDirection
      this.getData()
    },

    async getData() {
      this.loading = true
      try {
        const { data } = await this.$apollo.query({
          query: QUERY_LIST_PROPOSAL_OFFER_SCHEDULES,
          variables: this.queryVariables,
          fetchPolicy: 'no-cache',
        })

        this.dataCount = Math.ceil(data.offerSchedules.records / this.pageSize)
        this.offerSchedules = data.offerSchedules.offerSchedules
      } catch (error) {
        console.error(error)
        this.$snackbar({ message: 'Erro ao buscar dados no servidor', snackbarColor: 'error' })
      } finally {
        this.loading = false
        this.firstLoading = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.offer-schedule-list-container {
  padding: 24px;

  @media screen and (max-width: $xs-breakpoint) {
    padding: 12px;
  }

  .header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    gap: 12px;

    @media screen and (max-width: $xs-breakpoint) {
      flex-direction: column;
      align-items: flex-start;
    }
  }

  .title-container {
    @media screen and (max-width: $xs-breakpoint) {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 8px;
    }

    & span {
      font-size: 18px;
      font-weight: bold;
      color: $cinza-d10;
    }
  }

  .extra-container {
    display: flex;
    align-items: center;
    flex-direction: row;
    gap: 16px;
  }

  .item-loader {
    margin: 16px 0;
    border: 1px solid $cinza-l70;
    border-radius: 8px;
  }

  .progress-linear-substitute {
    height: 4px;
  }

  .empty-item {
    margin-bottom: 16px;
    border: 1px solid $cinza-l70;
    border-radius: 8px;
    height: 128px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    color: $cinza-l40;
  }
}

::v-deep .v-pagination__item {
  box-shadow: none !important;
}

::v-deep .v-pagination__navigation {
  box-shadow: none !important;
}
</style>
